import { render, staticRenderFns } from "./highlight-text.vue?vue&type=template&id=c1b1c6ac&scoped=true&lang=pug&"
import script from "./highlight-text.vue?vue&type=script&lang=js&"
export * from "./highlight-text.vue?vue&type=script&lang=js&"
import style0 from "./highlight-text.vue?vue&type=style&index=0&id=c1b1c6ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b1c6ac",
  null
  
)

export default component.exports